<template>
  <viewer :initialValue="text" />
</template>

<script>
import '@toast-ui/editor/dist/toastui-editor-viewer.css'
import { Viewer } from '@toast-ui/vue-editor'

export default {
    props: ['text'],

    components: {
        viewer: Viewer
    }
}
</script>

<style>

</style>
